<template>
    <v-dialog v-model="show" no-click-animation width="1000">
        <v-card>
            <v-layout class="headline grey lighten-2 pl-3 pr-2 py-2" primary-title align-center>
                <div>{{ $t('editor.nlp') }}</div>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <v-card-text>
                <v-tabs slider-color="primary" v-model="tab" style="height: calc(100vh - 290px); overflow: auto">
                    <v-tab>{{$t('sample')}}</v-tab>
                    <v-tab>{{$t('intent')}}</v-tab>
                    <v-tab>{{$t('entity')}}</v-tab>
                    <v-tab>{{$t('keyword')}}</v-tab>
                    <v-tab>{{$t('dictionary')}}</v-tab>
                    <v-tabs-items>
                        <v-tab-item>
                            <SampleList ref="SampleList"></SampleList>
                        </v-tab-item>
                        <v-tab-item>
                            <IntentList @sample="gotoSample($event)" ref="IntentList"></IntentList>
                        </v-tab-item>
                        <v-tab-item>
                            <EntityList
                                @sample="gotoSample($event)"
                                @keyword="gotoKeyword($event)"
                                ref="EntityList"
                            ></EntityList>
                        </v-tab-item>
                        <v-tab-item>
                            <KeywordList ref="KeywordList"></KeywordList>
                        </v-tab-item>
                        <v-tab-item>
                            <DictionaryList ref="DictionaryList"></DictionaryList>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
                <v-layout align-center v-if="isEditable">
                    <v-btn class="ml-0" @click="importData">{{ $t('importData') }}</v-btn>
                    <v-btn @click="exportData">{{ $t('exportData') }}</v-btn>
                    <v-btn @click="deleteData">{{ $t('deleteData') }}</v-btn>
                    <v-spacer></v-spacer>
                    <span class="mx-3" v-if="!trainData.training">Last train: {{trainData.lastTrain | formatDateTime}}</span>
                    <v-btn @click="train" :disabled="trainData.training" class="mr-0">
                        {{trainData.training ? $t('training') + '...' : $t('train')}}
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import IntentList from "@/views/Scenario/nlp/IntentList";
import SampleList from "@/views/Scenario/nlp/SampleList";
import EntityList from "@/views/Scenario/nlp/EntityList";
import NLP_Service from "@/services/nlp.service";
import KeywordList from "@/views/Scenario/nlp/KeywordList";
import DictionaryList from "@/views/Scenario/nlp/DictionaryList";
import { mapState } from "vuex";
import { ScenarioEventBus, ScenarioEventBusType } from "@/views/Scenario/scenario.eventbus";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "NLPEditor",
    components: { KeywordList, EntityList, SampleList, IntentList, DictionaryList },
    mixins: [DialogPromiseMixin],
    data () {
        return {
            tab: 0,
            trainData: {
                training: false,
                lastTrain: ''
            },
            subscription: null,
            isEditable: false
        }
    },
    computed: {
        ...mapState({
            scenario: state => state.scenario.scenario,
            sampleList: state => state.scenario.sampleList,
            intentList: state => state.scenario.intentList,
            entityList: state => state.scenario.entityList,
            keywordList: state => state.scenario.keywordList,
            dictionaryList: state => state.scenario.dictionaryList
        }),
    },
    mounted () {
        this.subscription = NLP_Service.TrainService.trainingStatusChange.subscribe(data => this.trainData = data)
    },
    destroyed () {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
    },
    methods: {
        gotoSample (filter) {
            this.tab = 0
            this.$refs.SampleList.filterItem(filter)
        },
        gotoKeyword (filter) {
            this.tab = 3
            this.$refs.KeywordList.filterItem(filter)
        },
        train () {
            NLP_Service.TrainService.train(this.$route.params.scenarioId)
        },
        importData () {
            ScenarioEventBus.$emit(ScenarioEventBusType.IMPORT_FILE, {
                resolve: file => {
                    const reader = new FileReader()
                    reader.readAsText(file, 'utf-8')
                    reader.onload = evt => {
                        NLP_Service.importData(this.$route.params.scenarioId, evt.target.result).then(
                            this.$appService.handleRequestSuccess(),
                            this.$appService.handleRequestError()
                        )
                    }
                }
            })
        },
        exportData () {
            NLP_Service.exportData(this.$route.params.scenarioId).then(
                result => {
                    this.$utils.downloadJSON(result.data, this.scenario.name)
                },
                this.$appService.handleRequestError()
            )
        },
        deleteData () {
            this.$appService.confirm('Do you want to delete all data').then(
                () => {
                    NLP_Service.deleteData(this.$route.params.scenarioId).then(
                        this.$appService.handleRequestSuccess(),
                        this.$appService.handleRequestError()
                    )
                }
            )
        }
    },
    watch: {
        scenario: {
            deep: true,
            handler: function () {
                this.isEditable = ScenarioService.isEditable()
            }
        }
    }
}
</script>

<style scoped>

</style>
